module.exports = __webpack_public_path__ + "img/certificate-icon.0077a0c0.png";